// Shared receipt printing helper
export function printReceipt(jobData = {}) {
  const COMPANY_INFO = {
    logoUrl: `${window.location.origin}/LOGO.jpeg`,
    name: 'Ranjith Electronics',
    address: 'No:18/1, Bandarawatta road, Aheliyagoda',
    phone: '036 2258631',
    email: 'ranjithelectroniceheliyagoda@gmail.com',
    serviceAgentTitle: 'Service Agent',
    warrantyText: '30 Days Service Warranty'
  };

  const jobRef = jobData.jobNumber || jobData._id || jobData.ref || '—';
  const getEscaped = (v) => (v || '').toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const html = `
  <!doctype html>
  <html>
  <head>
  <meta charset="utf-8" />
  <title>Customer Receipt - ${getEscaped(jobRef)}</title>
  <style>
  @page { size: A4; margin: 10mm }
  html,body { box-sizing: border-box }
  body { font-family: Arial, Helvetica, sans-serif; color: #111; margin: 0; padding: 12px; max-width:210mm; font-size:13px }
  .header { display:flex; justify-content:space-between; align-items:center; }
  .company { display:flex; align-items:center; gap:12px }
  .company img { width:56px; height:56px; object-fit:contain }
  .jobbox { border:2px solid #111; padding:8px 12px; font-weight:700; background:#f7f7f7 }
  .section { margin-top:14px; border-top:1px dashed #ddd; padding-top:10px }
  .section { page-break-inside: avoid }
  .two-col { display:flex; gap:20px }
  .col { flex:1 }
  table { width:100%; border-collapse:collapse }
  td, th { padding:6px 4px; vertical-align:top }
  .check { display:inline-block; width:12px; height:12px; border:1px solid #111; margin-right:6px }
  .right { text-align:right }
  .signature { height:40px; border-bottom:1px solid #000; margin-top:8px }
  .footer { font-size:12px; color:#666; margin-top:18px }
  @media print { body { margin: 8mm } .no-print { display:none } }
  </style>
  </head>
  <body>
  <div class="header">
    <div class="company">
      <img src="${COMPANY_INFO.logoUrl}" alt="logo" />
      <div>
        <div style="font-size:18px;font-weight:700">${getEscaped(COMPANY_INFO.name)}</div>
        <div style="font-size:12px">${getEscaped(COMPANY_INFO.address)}</div>
        <div style="font-size:12px">Phone: ${getEscaped(COMPANY_INFO.phone)}</div>
        <div style="font-size:12px">Email: ${getEscaped(COMPANY_INFO.email)}</div>
        <div style="margin-top:6px;font-size:12px;background:#eef2ff;color:#1e40af;padding:4px 6px;display:inline-block;border-radius:4px">${getEscaped(COMPANY_INFO.warrantyText)}</div>
      </div>
    </div>
    <div class="jobbox">Job No: ${getEscaped(jobRef)}</div>
  </div>

  <div class="section">
    <div style="font-weight:700;margin-bottom:6px">Customer Details</div>
    <table>
    <tr><td style="width:140px">Name</td><td>${getEscaped(jobData.customerName || jobData.customer || '')}</td></tr>
    <tr><td>Address</td><td>${getEscaped(jobData.customerAddress || '')}</td></tr>
    <tr><td>Phone</td><td>${getEscaped(jobData.customerPhone || '')}</td></tr>
    </table>
  </div>

  <div class="section">
    <div style="font-weight:700;margin-bottom:6px">Product / Device Details</div>
    <table>
    <tr>
    <td><strong>Product</strong>: ${getEscaped(jobData.deviceName || '')}</td>
    </tr>
    <tr>
    <td><strong>Model</strong>: ${getEscaped(jobData.deviceModel || '')}</td>
    </tr>
    <tr>
    <td><strong>S/N</strong>: ${getEscaped(jobData.serialNumber || '')}</td>
    </tr>
    </table>
  </div>

  <div class="section">
    <div style="font-weight:700;margin-bottom:6px">Accessories Present</div>
    <div>
    ${(() => {
      const raw = jobData.accessories || {};
      const knownKeys = ['remote', 'bracket', 'charger', 'powerCable'];
      const rows = [
        { k: 'remote', label: 'Remote Control' },
        { k: 'bracket', label: 'Wall Bracket' },
        { k: 'charger', label: 'Power Adaptor/Charger' },
        { k: 'powerCable', label: 'Power Cable' }
      ];
      let selected = {};
      let otherText = '';
      if (Array.isArray(raw)) {
        knownKeys.forEach((k) => { selected[k] = raw.includes(k); });
        const extras = raw.filter((v) => !knownKeys.includes(v) && v);
        otherText = extras.length ? extras.join(', ') : '';
      } else if (raw && typeof raw === 'object') {
        knownKeys.forEach((k) => { selected[k] = !!raw[k]; });
        otherText = raw.other || '';
      }
      const out = rows.map(r => {
        const checked = selected[r.k];
        const box = `<span style="display:inline-block;width:14px;height:14px;border:1px solid #111;margin-right:8px;text-align:center;line-height:14px;font-weight:700">${checked ? '✓' : ''}</span>`;
        return box + getEscaped(r.label);
      });
      if (otherText) out.push(getEscaped('Other: ' + otherText));
      return out.length ? out.join('<br/>') : 'None';
    })()}
    </div>
  </div>

  <div class="section">
    <div style="font-weight:700;margin-bottom:6px">Fault & Remarks</div>
    <div>${getEscaped(jobData.faultDescription || '') || '&nbsp;'}</div>
    <div style="margin-top:8px;font-weight:600">Technician Remarks / Observations</div>
    <div>${getEscaped(jobData.technicianRemarks || '') || '&nbsp;'}</div>
  </div>

  <div class="section">
    <div style="font-weight:700;margin-bottom:6px">Cost Details</div>
    <table>
    ${jobData.hideServiceCharge ? '' : `<tr><td>Service Charge</td><td class="right">${jobData.serviceCharge != null ? jobData.serviceCharge : (jobData.roughCost || 0)}</td></tr>`}
    <tr><td>Parts Cost</td><td class="right">${jobData.partsCost != null ? jobData.partsCost : 0}</td></tr>
    <tr><td><strong>Total Amount</strong></td><td class="right"><strong>${jobData.totalAmount != null ? jobData.totalAmount : (Number(jobData.roughCost || 0) + Number(jobData.partsCost || 0))}</strong></td></tr>
    <tr><td>Advance Paid</td><td class="right">${jobData.advanceAmount != null ? jobData.advanceAmount : 0}</td></tr>
    <tr><td>Balance Amount</td><td class="right">${((jobData.totalAmount != null ? jobData.totalAmount : (Number(jobData.roughCost || 0) + Number(jobData.partsCost || 0))) - (jobData.advanceAmount || 0)).toFixed(2)}</td></tr>
    </table>
  </div>

  <div class="section two-col">
    <div class="col">
      <div style="font-weight:700">Date</div>
      <table>
      <tr><td style="width:140px">Received Date</td><td>${getEscaped(jobData.createdAt ? new Date(jobData.createdAt).toLocaleString() : '')}</td></tr>
      <tr><td>Willing Handover Date</td><td>${getEscaped(jobData.willingHandoverDate ? new Date(jobData.willingHandoverDate).toLocaleString() : '')}</td></tr>
      <tr><td>Technician</td><td>${getEscaped(jobData.technicianName || COMPANY_INFO.serviceAgentTitle)}</td></tr>
      </table>
    </div>
    <div class="col" style="display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-end">
      <div style="width:260px;border-bottom:1px solid #000;height:40px"></div>
      <div style="font-size:12px;margin-top:6px">Authorized Signature</div>
    </div>
  </div>

  </body>
  </html>
  `;

  const w = window.open('', '_blank', 'width=900,height=680');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { console.error(e); } }, 400);
}

export default printReceipt;
